<!--
    描述：项目佣金发放
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    <template v-else>
      <div>
        当前项目雇主方发放佣金
        <span style="color: #0000FF">{{ tableData.length }}</span
        >次
      </div>
      <div class="mt10">
        <el-table
          :data="tableData"
          highlight-current-row
          row-key="id"
          border
          ref="table"
          style="width: 100%"
        >
          <el-table-column
            label="支付单号"
            prop="payNo"
            show-overflow-tooltip
            align="center"
            width="210"
          ></el-table-column>
          <el-table-column
            label="支付日期"
            prop="payDate"
            show-overflow-tooltip
            align="center"
            width="151"
          >
          </el-table-column>
          <el-table-column
            label="支付金额"
            prop="amount"
            align="center"
            width="151"
          >
            <template slot-scope="scope"> {{ scope.row.amount }}元 </template>
          </el-table-column>
          <el-table-column
            label="支付方式"
            prop="payMethod"
            show-overflow-tooltip
            min-width="151"
          ></el-table-column>
          <el-table-column
            label="支付渠道"
            show-overflow-tooltip
            prop="payAgent"
            min-width="171"
          ></el-table-column>
          <el-table-column align="center" label="到账方式" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.wayInAccount }}</span>
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  scope.row.wayInAccount == '企业资金账户'
                    ? '企业在平台开设的资金账户，可提现'
                    : '个人在平台开设的资金账户，可提现'
                "
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="w-table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { getBusSettlementPageList } from "api/modules/projectManagement";
export default {
  name: "pro-commission-issue",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      tableData: [],
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      currentRowData: {} // 当前行数据
    };
  },
  methods: {
    // 获取列表数据
    getBusSettlementPageList() {
      getBusSettlementPageList({
        subProjectId: this.rowData.businessId,
        current: this.currentPage,
        size: this.pageSize
      }).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBusSettlementPageList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBusSettlementPageList();
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped>
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
</style>
